import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../../auth/Context/AuthContext';
import Swal from 'sweetalert2';
import axios from '../../../adapters/API/axios';
import { useNavigate } from 'react-router-dom';
import { Col, Image, Modal, Row, Spinner } from 'react-bootstrap';
import LocationMarker from '../../MapsReader';
import { isMobile } from 'react-device-detect';

function ModalDetailLokasiVisit({
    rowSelected,
    showDetailLokasiVisit,
    setShowDetailLokasiVisit,
}) {

    const { tokens } = useContext(AuthContext);
    const tokenUser = tokens?.token;
    const [detailVisitMasuk, setDetailVisitMasuk] = useState();
    const [detailLokasiVisitMasuk, setDetailLokasiVisitMasuk] = useState();
    const [detailVisitKeluar, setDetailVisitKeluar] = useState();
    const [detailLokasiVisitKeluar, setDetailLokasiVisitKeluar] = useState();
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    const fetchListAdetailVisitMasuk = () => {
        setLoading(true);
        const startTime = Date.now(); // Track start time
        axios.get(`/api/visit/visitIn/${rowSelected?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {
                setDetailVisitMasuk(res.data)
                const [longitude, latitude] = res.data.visitIn_location
                    .match(/POINT \(([-0-9.]+) ([-0-9.]+)\)/)
                    .slice(1)
                    .map(Number);
                setDetailLokasiVisitMasuk({ longitude, latitude });

                // Ensure loading lasts at least 2 seconds
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            }).catch(err => {
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });

                    } else (console.log(err))
                }, delay);
            })
    };

    const fetchListAdetailVisitKeluar = () => {
        setLoading(true);
        const startTime = Date.now(); // Track start time
        axios.get(`/api/visit/visitOut/?visitIn=${rowSelected?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setDetailVisitKeluar(res.data[0])
                const [longitude, latitude] = res.data[0].visitOut_location
                    .match(/POINT \(([-0-9.]+) ([-0-9.]+)\)/)
                    .slice(1)
                    .map(Number);
                setDetailLokasiVisitKeluar({ longitude, latitude });

                // Ensure loading lasts at least 2 seconds
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            }).catch(err => {

                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });
                    } else (console.log(err))
                }, delay);
            })
    };

    useEffect(() => {
        const fetchData = async () => {
            if (rowSelected?.id !== undefined && tokenUser !== undefined) {

                await fetchListAdetailVisitMasuk();
                await fetchListAdetailVisitKeluar();
            }
        };

        fetchData();
    }, [rowSelected?.id, tokenUser]);

    const handleCloseModal = () => {
        setShowDetailLokasiVisit(false);

        setDetailVisitMasuk();
        setDetailVisitKeluar();
        setDetailLokasiVisitMasuk();
        setDetailLokasiVisitKeluar();
    };

    // console.log(detailVisitKeluar)

    return (
        <Modal
            show={showDetailLokasiVisit}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            centered
            size='xl'
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium' }}>
                    Detail Lokasi
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col style={{ borderRight: 'solid 1px' }}>
                        <p className='text-start' style={{ fontFamily: 'Poppins-Regular', fontSize: '19px' }}>Visit Masuk</p>

                        <div>
                            <p className='text-modal'>Lokasi: {detailVisitMasuk?.visitIn_place}</p>
                            <p className='text-modal'>Waktu: {detailVisitMasuk?.visitIn_time?.split('T')[0]} {detailVisitMasuk?.visitIn_time?.split('T')[1]?.split('.')[0]}</p>

                        </div>

                    </Col>
                    <Col style={{ borderLeft: 'solid 1px' }}>
                        <p className='text-end' style={{ fontFamily: 'Poppins-Regular', fontSize: '19px' }}>Visit Keluar</p>
                        <div>
                            {detailVisitKeluar ?
                                (
                                    <>
                                        <p className='text-modal  text-end'>Lokasi: {detailVisitKeluar?.visitOut_place}</p>
                                        <p className='text-modal  text-end'>Waktu: {detailVisitKeluar?.visitOut_time?.split('T')[0]} {detailVisitKeluar?.visitOut_time?.split('T')[1]?.split('.')[0]}</p>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <p className='text-modal  text-end'>User Tidak/Belum melakukan Visit Keluar</p>
                                    </>
                                )

                            }
                        </div>
                    </Col>
                </Row>
                <div className='mt-5 text-center'>
                    {loading && (
                        <div>
                            <div className='text-center'>
                                <Spinner animation="border" size='lg' className='my-4' style={{ color: '#000A2E' }} />
                            </div>

                        </div>
                    )}
                    {!loading && (
                        <Image
                            rounded
                            src={detailVisitKeluar?.picture}
                            fluid
                            style={{
                                width: '50%',
                                height: '50%',
                                objectFit: 'cover',
                            }}
                        />
                    )}
                </div>
                <Row className='mt-4'>
                    {loading && (
                        <div>
                            <div className='text-center'>
                                <Spinner animation="border" size='lg' className='my-4' style={{ color: '#000A2E' }} />
                            </div>
                        </div>
                    )}
                    {!loading && (

                        <LocationMarker lokasiMasuk={detailLokasiVisitMasuk} lokasiPulang={detailLokasiVisitKeluar} />
                    )}
                </Row>
                <div className='mt-1'>
                    <p style={{ fontFamily: 'Poppins-Regular', color: 'green', marginBottom: '0px', fontSize: '14px' }}>*Marker hijau: Visit Masuk</p>
                    <p style={{ fontFamily: 'Poppins-Regular', color: 'red', marginBottom: '0px', fontSize: '14px' }}>*Marker merah: Visit Keluar</p>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalDetailLokasiVisit
